// jshint esversion: 6

//History
//

if($(".history .history-gallery").length > 0){

    var checkw = "";
    $(function() {
        // first add init handler for Slick, then start up slick:
        $(".history .history-gallery")
            .on('init', function() {
                var _that = this;
                var timeLineElements = $('.history .nav-timeline li');
                timeLineElements.first().addClass('active');
                timeLineElements.on('click', function(evt) {
                    evt.stopPropagation();
                    timeLineElements.removeClass('active');
                    $(this).addClass('active');
                    var index = $(this).index();
                    $(_that).slick('slickGoTo', index);
                });
                if ($(window).width() < 768) {
                    var firstGallerySlider = $(_that).find('.history-gallery-slide[data-slick-index="0"]').eq(0).find('.gallery-images');
                    $(firstGallerySlider).on('init', function() {
                        var me = this;
                        window.requestAnimationFrame(function() {
                            $(me).slick('slickPlay');
                            // $(me).slick('slickSetOption', {
                            //     autoplay: true,
                            //   	// autoplaySpeed: 500,
                            //     infinite: true,
                            //     slidesToShow: 1,
                            //     slidesToScroll: 1
                            //   }, true);
                        });
                    });
                }
                var scrollCount = null;
                var scroll= null;
                var scrollSpeedLock = false;
                let scrollMaxOffset = 100;
                let scrollSpeed = 0;

                // Scroll Event für TimeLine:
                $(this).on('wheel', (function(e) {
                    e.preventDefault();

                    // Diese Methode erlaubt scrollen nur 1 Mal Pro Sekunde.
                    // scroll = setTimeout(function(){scrollCount=0;}, 1000);
                    // if(scrollCount) return 0;
                    // scrollCount=1;
                    var currentScrollSpeed = e.originalEvent.deltaY;
                    scrollCount += currentScrollSpeed;

                    // Logik, damit wir uns je nach ScrollSpeed immer nur einen Slide pro 5 Scrollbewegungen bewegen.
                    // ANnpassbar zum einen anhand des ScrollSpeed multiplikators, zum andern anhand der Zeit, wie Lnage das Skript
                    // im LOCK Zustand ist (Timeout Value)
                    if(!scrollSpeedLock && currentScrollSpeed !== scrollSpeed){
                        // Lock Scrollspeed change for a Second, so we can Adjust
                        scrollSpeedLock = true;
                        window.setTimeout(function(){scrollSpeedLock=false;}, 1000);
                        // Only Save Positive Values
                        scrollSpeed = currentScrollSpeed > 0 ? currentScrollSpeed: currentScrollSpeed * -1;
                        scrollMaxOffset = scrollSpeed * 5;
                    }

                    if (scrollCount > scrollMaxOffset) {
                        scrollCount = 0;
                        $(this).slick('slickNext');
                    } else if(scrollCount < scrollMaxOffset *-1 ) {
                        scrollCount = 0;
                        $(this).slick('slickPrev');
                    }
                }));

            })
            //
            .on('beforeChange', function(event, slick, currentSlide, nextSlide) {
                if(!slick.$slider.hasClass('gallery-images')){
                    let timeLineElements = $('.history .nav-timeline li');
                    let mySlideNumber = nextSlide;
                    timeLineElements.removeClass('active');
                    timeLineElements.eq(mySlideNumber).addClass('active');
                    let currentGallerySlider = $('.history .history-gallery').find('.history-gallery-slide[data-slick-index="' + currentSlide + '"]').eq(0).find('.gallery-images');
                    let nextGallerySlider = $('.history .history-gallery').find('.history-gallery-slide[data-slick-index="' + mySlideNumber + '"]').eq(0).find('.gallery-images');
                    let currentSlickState = $(nextGallerySlider).slick('getSlick');
                    if(currentSlickState.currentLeft < 0){
                            $(nextGallerySlider).slick('slickPrev');
                    }
                    $(currentGallerySlider).slick('slickPause');
                }
            })
            .on('afterChange', function(event, slick, currentSlide){
                let currentGallerySlider = $('.history .history-gallery').find('.history-gallery-slide[data-slick-index="' + currentSlide + '"]').eq(0).find('.gallery-images');
                // manually add Class, because here we can
                currentGallerySlider.find('.item').eq(0).addClass('slick-active').addClass('slick-current');
                $(currentGallerySlider).slick('slickGoTo', 0);
                if($(window).width() <= 768){
                    $(currentGallerySlider).slick('slickPlay');
                }
            })
            // History-gallery-slide
            .slick({
                infinite: false,
                arrows: false,
                fade: false,
                mobileFirst: true,
                rows: 0,
                draggable: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                responsive: [{
                    breakpoint: 767,
                    settings: {
                        fade: true,
                        speed: 400,
                        draggable: false
                    }
                }]
            });


        // first add init handler for Slick, then start up slick:
        $(".history .gallery-images")
            .on('init', function() {
                var _that = this;
                var thumbnail = $('.history .nav-gallery .thumbnail');
                thumbnail.on('click', function(thumb) {
                    thumb.stopPropagation();
                    $(thumbnail).removeClass('active');
                    $(this).addClass('active');
                    // var index = $(this).closest('.gallery-images').index();
                    var thumbindex = $(this).index();
                    // $(this).closest(_that).slick('slickGoTo', thumbindex);
                    let galleryImages = $(this).closest('.history-gallery-slide.slick-current').find('.gallery-images');
                    galleryImages.slick('slickGoTo', thumbindex);
                });

                // var active

                // let delta = 0;
                // let breakPoint = 100;
                // $(window).on('wheel', function(evt) {
                // 	evt.preventDefault();
                // 	let scrollTopOffset = evt.originalEvent.deltaY;
                // 	let scrollLeftOffset = evt.originalEvent.deltaX;
                // 	let scrolLDeepOffset = evt.originalEvent.deltaZ;
                // 	// make Breakpoint dynamic by ScrollValue of user
                // 	if(scrollTopOffset> 0){
                // 		breakPoint = scrollTopOffset * 10;
                // 	}
                // 	// scrollTop or Bottom will trigger delta Movement
                // 	delta += scrollTopOffset;
                // 	if (delta >= breakPoint) {
                // 		delta = 0;
                // 		// Scroll Top über Breakpoint
                // 		setTimeout(function() {
                // 			$('.history-gallery').slick('slickNext');
                // 		}, 1000);
                // 	}
                // 	if ((delta <= (breakPoint * -1) && delta < 0)) {
                // 		delta = 0;
                // 		// Scroll Top kleiner Breakpoint
                // 		$('.history-gallery').slick('slickPrev');
                // 	}
                // });

                // var timer;
                //
                // $(window).scroll(function(){
                //    if ( timer ) clearTimeout(timer);
                //    timer = setTimeout(function(){
                //        $('.history-gallery').slick('slickNext');
                //    }, 100);
                // });

                // var scrollCount = null;
                // var scroll= null;
                //
                // $(this).on('wheel', (function(e) {
                //   e.preventDefault();
                //
                //   scroll = setTimeout(function(){scrollCount=0;}, 200);
                //   if(scrollCount) return 0;
                //   scrollCount=1;
                //
                //   if (e.originalEvent.deltaY < 0) {
                //     $(this).slick('slickNext');
                //   } else {
                //     $(this).slick('slickPrev');
                //   }
                // }));


            })
            // gallery-images Slider
            .slick({
                infinite: true,
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                rows: 0,
                // focusOnSelect: true,
                // speed: 500,
                fade: true,
                cssEase: 'linear',
                mobileFirst: true,
                draggable: false,
                // autoplay: false,
                waitForAnimate: false,
                autoplaySpeed: 5000,
                responsive: [{
                    breakpoint: 768,
                    settings: {
                        // infinite: false,
                        autoplay: false
                    }
                }]
            });


        $('.nav-timeline li span').on({
            mouseenter: function() {
                $(this).parent().prev().addClass('prev');
            },
            mouseleave: function() {
                $(this).parent().prev().removeClass('prev');
            }
        });

        $('.nav-timeline .nav-items').on('scroll', function(evt) {
            // var scrollPos = this.scrollLeft;
            // var scrollMax = $(window).width();
            var children = $(this).find('li');

            $(children).removeClass('visible');
            $(children).removeClass('active');
            var visibleChildren = children.filter(function(index, element) {
            var elementLeft = $(element).offset().left;
            var elementRight = elementLeft + $(element).outerWidth();
            // var viewportLeft = $(window).scrollLeft() + $(element).outerWidth();
            var viewportLeft = $(window).scrollLeft() + ($(document).width() / 100 * 50);
            // var viewportRight = viewportLeft + $(window).width() - ($(element).outerWidth() * 2);
            var viewportRight = viewportLeft + $(window).width() - $(document).width();
            if ( elementRight > viewportLeft && elementLeft < viewportRight)
            {return true;} else {return false;}
            });
            $(visibleChildren).addClass('visible');
            // $(visibleChildren).show('visible');
        });

        $('.nav-timeline .btn-overview').click(function() {
            $('.history').toggleClass('overview');
            $('.history-gallery').toggleClass('overview');
            $('.gallery-images').slick('slickPause');
            var currentIndex = $('.history-gallery').slick('slickCurrentSlide');
            $('.nav-timeline li').removeClass('active');
            $('.nav-timeline li').eq(currentIndex).addClass('active');
            var leftOffset = currentIndex === 0 ? 0:  $('.nav-timeline li').eq(currentIndex).offset().left;

            // console.group("before");
            // console.log('currentScrollPos: '+ $('.nav-timeline ul.nav-items').scrollLeft());
            // for (var u = 0; u< $('.nav-timeline li').length; u++){
            // 	console.log("u: " + u+ " offset: "+ $('.nav-timeline li').eq(u).offset().left);
            // }
            // console.groupEnd();

            var scrollOffset =leftOffset + $('.nav-timeline ul.nav-items').scrollLeft() - 100;
                // console.log('setting scrollTarget:' + scrollOffset);
            $('.nav-timeline .nav-items').scrollLeft(scrollOffset);

        });

        if ($(window).width() < 768) {
            $('.history .nav-timeline li').click(function() {
                $(this).closest('.history.overview').removeClass('overview');
            });

            $('.scrollbar-external').scrollbar({
                "autoScrollSize": false,
                "scrollx": $('.external-scroll_x'),
            });
        }

    });

}